<template>
  <v-switch v-model="activated"></v-switch>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  name: "DigitalAccountLiquidationSwitch",
  data() {
    return {
      sendDepositsToFlowitWallet: false
    };
  },
  created() {
    this.$store.dispatch("account/getAccount");
  },
  watch: {
    account: {
      handler() {
        this.sendDepositsToFlowitWallet = this.account.send_deposits_to_flowit_wallet;
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      account: "account/account"
    }),
    activated: {
      get() {
        return this.sendDepositsToFlowitWallet;
      },
      set(newValue) {
        this.sendDepositsToFlowitWallet = newValue;
        this.$store.dispatch("account/updateLiquidationAccount", newValue);
      }
    }
  }
};
</script>
